/**
 * Shared helpers for CSV/PDF blob downloads.
 *
 * - `parseFilenameFromHeader` reads RFC 5987 `filename*=UTF-8''…` first, then plain `filename=…`.
 * - `downloadBlob` triggers a synthetic <a download> click and revokes the blob URL.
 * - `formatYmd` produces a `YYYYMMDD` string for filename suffixes.
 */

import { formatDateYmd } from './dateFormat';

const BLOB_URL_REVOKE_DELAY_MS = 10_000;

export function parseFilenameFromHeader(value: string | undefined | null): string | null {
  if (!value) return null;

  const utf8Match = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(value);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch {
      /* fall through */
    }
  }

  const plainMatch = /filename\s*=\s*"?([^";]+)"?/i.exec(value);
  if (plainMatch) {
    return plainMatch[1].trim();
  }
  return null;
}

export function formatYmd(d: Date = new Date()): string {
  return formatDateYmd(d, '');
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), BLOB_URL_REVOKE_DELAY_MS);
}
